export default {"src":"/_next/static/media/V.710acdc0.svg","height":18,"width":18};